import * as React from 'react';
import styled from 'styled-components';

// Components
import { TextField } from '../../../../../../../../../components/TextField';
import { PlainRenderElementsWrapper } from './PlainRenderInputElement';

// Context
import { RuleEditorContext } from '../../context';

// Enums
import { dtoState } from '../../../../../../../../../common/enums/dtoState';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';
import { useCriteriaStoreUpdatePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStoreUpdatePredicate';
import { useDebouncedStringCallback } from '../../../../../../hooks/useDebouncedStringCallback';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

const QuantityContainer = styled.div`
    max-width: 8rem;
`;

const UnitContainer = styled.div`
    max-width: 10rem;
`;

export const DataInputQuantity = ({ id, plainrender = true, ...props }) => {
    const { setEdited } = React.useContext(RuleEditorContext);
    const part = useCriteriaStorePredicate(id);
    const updatePredicateElement = useCriteriaStoreUpdatePredicate();
    const [amountValue, setAmountValue] = useDebouncedStringCallback({
        startVal: part?.dataInputNumeric,
        debounceCallback: (newVal) => {
            setEdited(true);
            updatePredicateElement({
                ...part,
                dtoState: dtoState.Updated,
                dataInputNumeric: newVal
            });
        }
    });
    const [unitValue, setUnitValue] = useDebouncedStringCallback({
        startVal: part?.text,
        debounceCallback: (newVal) => {
            setEdited(true);
            updatePredicateElement({
                ...part,
                dtoState: dtoState.Updated,
                text: newVal
            });
        }
    });

    if (plainrender) {
        return (
            <PlainRenderElementsWrapper
                overridable={part?.overridable}
                items={[
                    { value: amountValue, placeholderPartial: 'quantity amount' },
                    { value: unitValue, placeholderPartial: 'quantity unit' }
                ]}
            />
        );
    }
    return (
        <>
            <QuantityContainer>
                <TextField
                    withBorder
                    size={'xs'}
                    id={`part_quantity_amount_${id}`}
                    name={`part_quantity_amount_${id}`}
                    value={amountValue}
                    onInput={(e) => {
                        setAmountValue(e.target.value);
                    }}
                    style={{
                        width: '100%'
                    }}
                    placeholder={'Enter amount'}
                />
            </QuantityContainer>
            <UnitContainer>
                <TextField
                    withBorder
                    size={'xs'}
                    id={`part_quantity_unit_${id}`}
                    name={`part_quantity_unit_${id}`}
                    value={unitValue}
                    onInput={(e) => {
                        setUnitValue(e.target.value);
                    }}
                    placeholder={'Enter unit'}
                />
            </UnitContainer>
        </>
    );
};

export default DataInputQuantity;

DataInputQuantity.propTypes = {
    ...ruleEditorViewPartCommonProps
};
